import {
  setGlobalAttributesResolver,
  setGlobalErrorHandler,
  setHeuristics,
} from './global-state';
import { ClickHeuristic, DomMutationHeuristic, EventAttributes } from './types';

type InitAnalyticsArgs = {
  heuristics?: {
    click?: ClickHeuristic[];
    domMutation?: DomMutationHeuristic[];
  };
  globalAttributesResolver?: () => EventAttributes;
  globalErrorHandler?: (error: unknown) => void;
};

export const initAnalytics = ({
  heuristics,
  globalAttributesResolver,
  globalErrorHandler,
}: InitAnalyticsArgs = {}) => {
  if (heuristics) {
    setHeuristics(heuristics);
  }
  if (globalAttributesResolver) {
    setGlobalAttributesResolver(globalAttributesResolver);
  }
  if (globalErrorHandler) {
    setGlobalErrorHandler(globalErrorHandler);
  }
};
